import type { PageGuide } from '../../components/guide/guideTypes'
import { curatedDeepGuides } from './curatedDeepGuides'
import { generatedPageGuides } from './generatedGuides'
import { coreGuides } from './coreGuides'

/**
 * Registry order: curated deep guides win (more specific scoring),
 * then core, then auto-generated detailed guides for every menu page.
 */
export const guideRegistry: PageGuide[] = [
  ...curatedDeepGuides,
  ...coreGuides,
  ...generatedPageGuides,
]
